'use client'

import { useEffect, useState } from 'react'

import { createGenericContext } from '../../../../../../contexts/generic-context'
import type { IShipment, IStop } from '../../../../../../types/shipment'

interface StopsState {
  editingStopId: string | null
  setEditingStopId: (id: string | null) => void
  shipment: IShipment
  stops: IStop[]
  updateStops: (stops: IStop[]) => void
}

const [useStops, StopsContextProvider] = createGenericContext<StopsState>(
  'useStops must be used within StopsContextProvider'
)

/**
 * This provider is used to provide the stops context to its children.
 * It provides the shipment and stops data and a function to update the stops.
 */
const StopsProvider = ({ children, shipment }: { children: React.ReactNode; shipment: IShipment }) => {
  const [stops, setStops] = useState(shipment.stops ?? [])
  const [editingStopId, setEditingStopId] = useState<string | null>(null)

  useEffect(() => {
    // Update stops when shipment stops change
    setStops(shipment.stops ?? [])
  }, [shipment.stops])

  const value = {
    editingStopId,
    setEditingStopId,
    shipment,
    stops,
    updateStops: (newStops: IStop[]) => {
      setStops(newStops)
    }
  }

  return <StopsContextProvider value={value}>{children}</StopsContextProvider>
}

export { StopsProvider, useStops }
